<p-toast position="top-center" key="remove-wishlist" [baseZIndex]="15000"></p-toast>
<div class="innerBanner" style="background-image: url('../../../assets/images/home-slick-slider-3.avif')">
  <div class="bannerText"></div>
</div>
<!-- <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="/home">Home</a></li>
    <li class="breadcrumb-item active" aria-current="page">Wishlist</li>
  </ol>
</nav> -->

<div class="container">
  <div class="contentPanel">
    <!-- <app-breadcrumb></app-breadcrumb> -->
    <app-breadcrumb-row></app-breadcrumb-row>
    <h1 *ngIf="isLoading || whistlist.length > 0">{{ 'Wishlist' | translate }}</h1>
  </div>
  <!-- <div class="row">
    <div class="col-md-12">
      <div class="Wishlist" *ngFor="let item of whistlistItems">
        <div class="image">
          <img class="wish-img" width="100" height="120" src="{{ item.productImage }}" />
          <h2>{{ item.productName }}</h2>
          <p>
            {{ item.productDescription }}
            <a class="p-button-text" (click)="viewMoreDetils(item.productId)">{{ 'View Details' | translate }}</a>
          </p>
          <h6>
            <i class="icon-location"></i> {{ item.addresses[0].islandArea
            }}<span *ngIf="item.addresses[0].islandArea && item.addresses[0].island">,&nbsp;</span
            >{{ item.addresses[0].island }}
          </h6>
          <a class="btn btn-info" style="float: right" (click)="removeWishList(item.productId)">{{
            'Remove' | translate
          }}</a>
        </div>
      </div>
    </div>
  </div> -->

  <div class="p-grid accommodationGrid">
    <div class="p-lg-12" style="padding: 15px !important">
      <!-- Empty State Message -->
      <div *ngIf="!isLoading && whistlist.length === 0" class="empty-wishlist">
        <div class="empty-wishlist-content">
          <i class="fa fa-heart-o empty-heart-icon"></i>
          <h3>{{ 'Your wishlist is empty' | translate }}</h3>
          <p>{{ 'Start exploring and save your favorite places to visit!' | translate }}</p>
          <a routerLink="/planyourvisit/wheretostay" class="btn-explore">{{ 'Explore Destinations' | translate }}</a>
        </div>
      </div>
      <div class="p-grid" *ngIf="whistlist.length > 0">
        <div class="p-col-12 p-md-6 p-lg-3" *ngFor="let item of whistlist">
          <p-card>
            <ng-template pTemplate="header">
              <div>
                <a target="_blank" class="product-item alisting" [href]="'/listingdetails/' + item.productId">
                  <div class="CategoriesImages" [style.background-image]="'url(' + item.productImage + ')'">
                    <img class="wish-img" width="100" height="120" src="{{ item.productImage }}" />
                  </div>
                </a>
                <div *ngIf="item.rateFrom" class="accomodationPrice wishlistPrice">
                  <a target="_blank" class="product-item alisting" [href]="'/listingdetails/' + item.productId">
                    <div class="price">
                      <h3>{{ 'starting from' | translate }}</h3>
                      SCR {{ item.rateFrom | number }}
                    </div>
                  </a>
                </div>
                <span class="wishlistHeart" (click)="$event.stopPropagation()">
                  <a (click)="removeWishList(item.productId)"><i class="fa fa-heart wishlist"></i></a>
                </span>
              </div>
              <div class="accBookMark">
                <img *ngFor="let accr of item.accredations" [src]="accr" />
              </div>
            </ng-template>

            <a target="_blank" class="product-item alisting" [href]="'/listingdetails/' + item.productId">
              <div class="locationTitle">
                <div *ngIf="item.starRating >= 0">
                  <p-rating [(ngModel)]="item.starRating" [cancel]="false" readonly="true "></p-rating>
                </div>
                <div class="locationName list-comma" *ngFor="let classification of item.classification">
                  <span>{{ classification }}</span>
                </div>
                <h5>{{ item.productName }}<i class="icon-safe"></i></h5>

                <div class="locationName" *ngIf="item.location[0].island">
                  <i class="icon-location"></i>{{ item.location[0].islandArea
                  }}<span *ngIf="item.location[0].island && item.location[0].islandArea">,&nbsp;</span
                  >{{ item.location[0].island }}
                </div>
              </div>
            </a>
          </p-card>
        </div>
      </div>
    </div>
  </div>
</div>
